import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeading from '../../@communityshare/ui/PageHeading';
import MobileSubNavigation from './MobileSubNavigation';

export default function Layout({
  title,
  breadcrumbs,
  subhead,
  description,
  pageLinks,
  children,
}) {
  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {pageLinks && <MobileSubNavigation pageLinks={pageLinks} />}
      <PageHeading
        breadcrumbs={breadcrumbs}
        title={title}
        subhead={subhead}
        description={description}
      />
      <div className="flex flex-col items-center justify-center mt-4">
        {children}
      </div>
    </div>
  );
}
